export default "__VITE_ASSET__BtYURAwO__"